import $ from 'jquery';
const reviews = {
	list: false,

	init() {
		$(document).on("click", ".__best_reviews > li", function () {
			const reviewId = $(this).data("review");
			reviews.loadReviews(reviewId);
		});

		$(document).on("click", "._load_reviews", function () {
			reviews.loadReviews();
		});
	},

	loadReviews(reviewId) {
		if (this.list === false) {
			$.ajax({
				url: `${_SITE_URL}get-reviews`,
				type: 'post',
				data: {
					product_id: product.id
				},
				success(response) {
					if (response) {
						product.list_reviews = $.parseJSON(response);

						let listFrom = '';
						$.each(product.list_reviews.from, function (i, el) {
							listFrom += `
                                <li data-from="${el.id}">
                                    <div class="cc-checkbox-outer _small _grey">
                                        <input checked="checked" class="__check" type="checkbox" data-from="${el.id}" name="from[${el.id}]" id="from[${el.id}]">
                                        <div class="cc-checkbox-inner"></div>
                                    </div>
                                    <div class="_filter_title"><span>${el.label}</span></div>
                                </li>`;
						});

						$(".--filter_from").html(`<ul>${listFrom}</ul>`);
						$(".nb_reviews").html(`${product.list_reviews.nb_reviews} <small>Reviews</small>`);
						$(".--list_reviews").html(product.list_reviews.content);

						setTimeout(() => {
							const scrollTarget = reviewId
								? $(`.__review_bl[data-id=${reviewId}]`).position().top
								: 0;
							$(".__contain_reviews").mCustomScrollbar("scrollTo", scrollTarget);
						}, 600);

						$("html,body").css("overflow", "hidden");
						$(".--modal-reviews").addClass("_show");

						reviews.filters();
					}
				}
			});
		} else if ($.type(product.list_reviews) === "object") {
			$("html,body").css("overflow", "hidden");
			$(".--modal-reviews").addClass("_show");
			this.filters();
		}
	},

	filters() {
		$(document).on("change", ".__check", function () {
			const from = $(this).data("from");
			const isChecked = $(this).prop("checked");

			$(`.__review_bl[data-from=${from}]`).toggle(isChecked);

			const visibleCount = $('.__review_bl:visible').length;
			$(".nb_reviews").html(`${visibleCount} <small>Reviews</small>`);
		});

		$(document).on("click", ".--filter-asc", function () {
			$(".--filter-asc").removeClass("_activ");
			$(this).addClass("_activ");

			const type = $(this).data("filter");
			const elements = $(".__review_bl");
			const arr = [];

			elements.each(function () {
				arr.push({
					rate: $(this).data("rate"),
					date: $(this).data("date"),
					elt: this
				});
			});

			arr.sort(reviews.sortBy(type, 'desc'));

			$(".--list_reviews").empty();
			$.each(arr, function (i, e) {
				$(".--list_reviews").append(e.elt);
			});
		});
	},

	sortBy(key, order = 'asc') {
		return function (a, b) {
			if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
				return 0;
			}

			const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key];
			const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key];

			let comparison = 0;
			if (varA > varB) {
				comparison = 1;
			} else if (varA < varB) {
				comparison = -1;
			}

			return (order === 'desc') ? comparison * -1 : comparison;
		};
	}
};

export default reviews;
